const OfferModalInit = () => {
  const modalBase = document.querySelector(".modal");
  const modalItem = document.querySelector(".open-modal");
  const cf7Form = document.querySelector(".wpcf7");
  let autoOpenModalActive = false;

  if (modalBase !== null && modalItem !== null && cf7Form !== null) {
    const productId = modalItem.dataset.productId;
    const productName = modalItem.dataset.productName;
    const productSku = modalItem.dataset.productSku;
    const productCategories = modalItem.dataset.productCategories;

    const openModal = () => {
      if (modalBase.classList.contains("is-active")) {
        modalBase.classList.remove("is-active");
        modalBase.querySelector(".modal__bg").classList.remove("is-active");
        modalBase.querySelector(".modal__inner").classList.remove("no-transition");
        modalBase.querySelector(".modal__inner").classList.remove("is-active");
      } else {
        modalBase.classList.add("is-active");
        setTimeout(function () {
          modalBase.querySelector(".modal__bg").classList.add("is-active");
          if (autoOpenModalActive) {
            modalBase.querySelector(".modal__inner").classList.add("no-transition");
          }
          modalBase.querySelector(".modal__inner").classList.add("is-active");

          autoOpenModalActive = false;
        }, getDelay());
      }
    };

    const closeModal = () => {
      modalBase.querySelector(".modal__bg").classList.remove("is-active");
      modalBase.querySelector(".modal__inner").classList.remove("no-transition");
      modalBase.querySelector(".modal__inner").classList.remove("is-active");
      setTimeout(function () {
        modalBase.classList.remove("is-active");
      }, 250);
    };

    const getDelay = () => {
      let delay = 250;
      if (autoOpenModalActive) {
        delay = 0;
      }

      return delay;
    };

    cf7Form.querySelector('input[name="product-name"]').value = productName;
    cf7Form.querySelector('input[name="product-sku"]').value = productSku;
    cf7Form.querySelector('input[name="product-categories"]').value = productCategories;

    modalItem.addEventListener("click", function (e) {
      e.preventDefault();
      const itemContent = document.querySelector(".modal-item").innerHTML;
      const closeButton =
        '<button type="button" class="btn-close">\n' +
        '  <span class="icon-cross"></span>\n' +
        '  <span class="visually-hidden">Close</span>\n' +
        "</button>";
      const closeLink = '<a href="#" class="link-close">\n' + " <span>Sluit venster </span><span>[X]</span>\n" + "</a>";
      modalBase.querySelector(".modal__inner").innerHTML = itemContent;
      // modalBase.innerHTML += closeButton;
      modalBase.querySelector(".modal__inner").innerHTML += closeLink;
      modalBase.querySelector("a.link-close").addEventListener("click", function (e) {
        e.preventDefault();
        closeModal();
      });
      const formTitle = modalBase.querySelector(".modal__inner h3");

      const createElement = (content = ``, type = `p`) => {
        let container = document.createElement(type);
        container.innerHTML = content;

        return container;
      };

      const productInfoEl = createElement(`<b>Product</b>: ${productName} <br /><b>Artikelnummer</b>: ${productSku}`);

      formTitle.after(productInfoEl);

      const formToInit = modalBase.querySelector(".wpcf7-form");

      wpcf7.init(formToInit);

      // fix: remove double spinner
      formToInit.querySelector("span.wpcf7-spinner:last-of-type").remove();

      openModal();
    });

    modalBase.querySelector(".modal__bg").addEventListener("click", function (e) {
      e.preventDefault();
      closeModal();
    });

    /* CF7 Hacks */
    const cf7IsSubmitted = window.location.hash.includes("wpcf7");
    if (cf7IsSubmitted === true) {
      autoOpenModalActive = true;
      modalItem.click();
    }

    const cf7Output = modalBase.querySelector(".wpcf7-response-output");

    const cf7HasOutput = cf7Output !== null && cf7Output.innerHTML !== "";
  }
};

export default OfferModalInit;
